import { UniTabHeader } from '@/design-system/components/tabs';
import { ScrollView, useDripsyTheme } from 'dripsy';
import { useEffect } from 'react';
import { useWindowDimensions } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { useStore } from 'store/store';

interface UniNativeModalProps {
  title?: string;
  onBack?: () => void;
  showBackButton?: boolean;
  showHeader?: boolean;
  backgroundColor?: string;
}

export const UniNativeModal: React.FC<UniNativeModalProps> = ({
  title,
  showBackButton,
  showHeader = true,
  backgroundColor,
  onBack,
  children
}) => {
  const dimensions = useWindowDimensions();

  const right = useSharedValue(-dimensions.width);

  const animatedStyle = useAnimatedStyle(() => ({
    right: withTiming(right.value, { duration: 300 })
  }));

  const theme = useDripsyTheme();

  useEffect(() => {
    right.value = 0;
  }, []);

  const handleBack = () => {
    right.value = -dimensions.width;
    setTimeout(() => {
      onBack && onBack();
    }, 500);
  };

  const store = useStore();
  const defaultBackground = store.theme === 'dark' ? '#1A1A1A' : '#FFFFFF';

  return (
    <Animated.View
      style={[
        {
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%',
          backgroundColor: backgroundColor || theme.colors?.$backgroundPrimary || defaultBackground
        },
        animatedStyle
      ]}>
      <ScrollView sx={{ flex: 1 }} contentContainerSx={{ height: '100%', flex: 1 }}>
        {showHeader && <UniTabHeader title={title || ''} onBack={handleBack} showBackButton={showBackButton} />}
        {children}
      </ScrollView>
    </Animated.View>
  );
};
